import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Contact = ({ contactRef }) => {

    return (
        <div className='contact' ref={contactRef}>

            <div className='links'>
                <div className="links-container">
                    <div className="email-wraper">
                        <FontAwesomeIcon icon={['fas', 'paper-plane']} size='1x' color='#ff8c00' />
                        <p>
                            NourWagdyNasr@gmail.com
                        </p>
                    </div>
                    <a href='https://www.linkedin.com/in/nour-wagdy-932918184' target="_blank" rel="follow noreferrer" >
                        <FontAwesomeIcon icon={['fab', 'linkedin']} size='2x' color='yellow' />
                    </a>

                    <a href='https://github.com/NourBasha' target="_blank" rel="follow noreferrer">
                        <FontAwesomeIcon icon={['fab', 'github-square']} size='2x' color='yellow' />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Contact;